import { render, staticRenderFns } from "./TrainingPlanChoose.vue?vue&type=template&id=606a9387&scoped=true&"
import script from "./TrainingPlanChoose.vue?vue&type=script&lang=js&"
export * from "./TrainingPlanChoose.vue?vue&type=script&lang=js&"
import style0 from "./TrainingPlanChoose.vue?vue&type=style&index=0&id=606a9387&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606a9387",
  null
  
)

export default component.exports